<template>
    <div class="grid mt-2">
        <div class="col-12">
            <h5 class="heading-1">
                <span>ANEXOS</span>
            </h5>
            <tabela
                :data="anexos"
                dataKey="convenioAnexoId"
                :globalFilterFields="['nomeArquivo', 'tipo']"
                stateKey="dt-rm-convenios-execucao-direta-receita-anexos"
            >
                <template #conteudo>
                    <Column headerStyle="width: 3em">
                        <template #body="slotProps">
                            <div class="flex">
                                <btn-excluir-anexo-receita
                                    :anexo="slotProps.data"
                                    :services="services"
                                    :convenio="convenio"
                                    @obterAnexosAtualizados="obterAnexosAtualizados()"
                                    class="ml-2"
                                ></btn-excluir-anexo-receita>
                                <font-awesome-icon
                                    icon="download"
                                    @click="download(slotProps.data)"
                                    size="lg"
                                    class="icon-button ml-2 p-text-primary"
                                    title="Download"
                                    v-if="slotProps.data"
                                />
                                <font-awesome-icon
                                    v-if="podeVisualizar(slotProps.data.nomeArquivo)"
                                    icon="search"
                                    @click="abrir(slotProps.data)"
                                    size="lg"
                                    class="icon-button ml-2"
                                    title="Visualizar anexo"
                                />
                                <visualizar-anexo :mostrar="mostrar" :titulo="titulo" @cancelar="fechar()">
                                    <iframe v-if="arquivo" :src="arquivo" :title="titulo" style="width: 100%; height: 850px"></iframe>
                                </visualizar-anexo>
                            </div>
                        </template>
                    </Column>
                    <Column field="nomeArquivo" header="Arquivo" :sortable="true">
                        <template #body="slotProps">
                            {{ slotProps.data.nomeArquivo }}
                        </template>
                    </Column>
                    <Column field="tipo" header="Tipo" :sortable="true">
                        <template #body="slotProps">
                            {{ slotProps.data.tipo }}
                        </template>
                    </Column>
                </template>
            </tabela>
        </div>
        <!-- Visualizar Anexo Dialog - outside the table loop -->
    </div>
</template>

<script>
import BtnExcluirAnexoReceita from './BtnExcluirAnexoReceita';
import VisualizarAnexo from '@/app/licitacoes/solicitacoes/VisualizarAnexo';
import Services from './services';

export default {
    emits: ['obterAnexosAtualizados'],

    props: {
        anexos: { type: Object },
        convenio: { type: Object },
        services: { type: Object },
    },
    data() {
        return {
            mostrar: false,
            titulo: '',
            arquivo: null,
        };
    },

    components: {
        BtnExcluirAnexoReceita,
        VisualizarAnexo,
    },

    methods: {
        obterAnexosAtualizados() {
            this.$emit('obterAnexosAtualizados');
        },
        download(anexo) {
            this.$store.dispatch('addRequest');
            Services.baixarAnexoReceita(this.convenio.idCnt, anexo.convenioAnexoId)
                .then((response) => {
                    if (response && response.data) {
                        this.$download(response.data, `${anexo.nomeArquivo}`);
                    } else {
                        this.$toast.add({
                            severity: 'error',
                            summary: 'Baixar Anexo',
                            detail: 'Erro ao realizar download do anexo',
                            life: 3000,
                        });
                    }
                    this.$store.dispatch('removeRequest');
                })
                .catch((error) => {
                    console.error('Erro ao baixar anexo:', error);
                    this.$toast.add({
                        severity: 'error',
                        summary: 'Baixar Anexo',
                        detail: 'Erro ao realizar download do anexo',
                        life: 3000,
                    });
                    this.$store.dispatch('removeRequest');
                });
        },
        fechar() {
            if (!this.mostrar) return;
            this.mostrar = false;
        },
        podeVisualizar(filename) {
            const lowerCaseFilename = filename.toLowerCase();
            const extension = lowerCaseFilename.slice(lowerCaseFilename.lastIndexOf('.'));
            switch (extension) {
                case '.doc':
                case '.docx':
                case '.xls':
                case '.xlsx':
                case '.zip':
                case '.txt':
                    return false;
                default:
                    return true;
            }
        },
        abrir(anexo) {
            this.$store.dispatch('addRequest');
            this.titulo = anexo.nomeArquivo;
            Services.baixarAnexoReceita(this.convenio.idCnt, anexo.convenioAnexoId)
                .then((response) => {
                    if (response && response.data) {
                        const blob = new Blob([response.data], { type: this.getMimeType(anexo.nomeArquivo) });

                        this.arquivo = window.URL.createObjectURL(blob);

                        this.mostrar = true;
                    } else {
                        this.$toast.add({
                            severity: 'error',
                            summary: 'Visualizar Anexo',
                            detail: 'Erro ao abrir anexo (dados ausentes na resposta)',
                            life: 3000,
                        });
                    }
                    this.$store.dispatch('removeRequest');
                })
                .catch(() => {
                    this.$toast.add({
                        severity: 'error',
                        summary: 'Visualizar Anexo',
                        detail: 'Erro ao abrir anexo',
                        life: 3000,
                    });
                    this.$store.dispatch('removeRequest');
                });
        },
        getMimeType(filename) {
            const lowerCaseFilename = filename.toLowerCase();
            const extension = lowerCaseFilename.slice(lowerCaseFilename.lastIndexOf('.'));
            switch (extension) {
                case '.pdf':
                    return 'application/pdf';
                case '.png':
                    return 'image/png';
                case '.jpeg':
                case '.jpg':
                    return 'image/jpeg';
                case '.doc':
                    return 'application/msword';
                case '.docx':
                    return 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
                case '.xls':
                    return 'application/vnd.ms-excel';
                case '.xlsx':
                    return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                default:
                    return 'application/octet-stream';
            }
        },
    },
};
</script>
